import { useEffect } from 'react';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { setSelectedMeasureOverTime } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { useSelectedMeasureOverTime } from '../../../../store/process-analysis-store/process-analysis-store.hooks';

/**
 * Hook to handle auto-initialization of key measures over time filters
 *
 * @returns {void}
 */
const useAutoSelectFilters = (): void => {
  const availableMeasures = useProcessAnalysisStore((state) => state.availableMeasures);
  const selectedMeasureOverTime = useSelectedMeasureOverTime();

  useEffect(() => {
    if (availableMeasures.length === 0) return;

    const defaultMeasure = availableMeasures[0].measure_name;
    const exists = availableMeasures.some((measure) => measure.measure_name === selectedMeasureOverTime);

    if (!selectedMeasureOverTime || !exists) {
      setSelectedMeasureOverTime(defaultMeasure);
    }
  }, [availableMeasures, selectedMeasureOverTime]);
};

export { useAutoSelectFilters };
